import React from 'react';
import { MessageSquare } from 'lucide-react';
import { FeedbackFlow } from '../Feedback/FeedbackFlow';
/**
 * The landing "Share your story" feedback section.
 * This is a feedback / review surface — the scan flow lives elsewhere.
 */
export function ShareYourStorySection() {
  return <section id="share-your-story" aria-labelledby="share-your-story-title" className="border-t border-gray-900 bg-[#050505] py-24" data-id="element-2827" data-mp="1p0yaxjqtbkut">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,520px)] lg:gap-16" data-id="element-2828" data-mp="11bdmwmfsxxeo">
        <header className="max-w-xl" data-id="element-2829" data-mp="wa6gaqpeb49l">
          <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#FF0000]" data-id="element-2830" data-mp="1b16znqrokiki">
            Share your story
          </p>
          <h2 id="share-your-story-title" className="text-3xl font-black uppercase leading-none tracking-tight text-white md:text-5xl" data-id="element-2831" data-mp="168m5up8ry5gz">
            How was your experience?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-gray-400" data-id="element-2832" data-mp="djp1lq1ee978">
            Your honest feedback helps us make the experience clearer and more
            useful.
          </p>
          <p className="mt-8 flex items-start gap-3 text-sm leading-relaxed text-gray-500" data-id="element-2833" data-mp="1gk5b9sba7ku2">
            <MessageSquare size={16} aria-hidden="true" className="mt-0.5 shrink-0 text-gray-600" data-id="element-2834" data-mp="1ldhwrtknzbil" />
            Private notes go straight to our support team. Public reviews are
            always your choice.
          </p>
        </header>

        <div className="rounded-2xl border border-gray-800 bg-[#0A0A0A] p-6 sm:p-8" data-id="element-2835" data-mp="xnnj59sitixa">
          <FeedbackFlow idPrefix="share-your-story" data-id="element-2836" data-mp="11nxqoqvyohe9" />
        </div>
      </div>
    </section>;
}